// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"97d25de6","897":"9ba2d812"}[chunkId] + ".chunk.js";
};